//wordpress dependencies
const { __ } = wp.i18n;
const { InspectorControls, PanelColorSettings, MediaUpload } = wp.blockEditor;
import {
	TextControl, BaseControl, Button, ButtonGroup, ColorPalette, Dropdown, PanelBody, RangeControl, SelectControl, TabPanel, ToggleControl, __experimentalUnitControl as UnitControlEMG
} from "@wordpress/components";
const { useEffect, useState } = wp.element;

//internal dependencies
import ColorControl from "../../util/color-control";
import DimensionsControl from "../../util/dimensions-control";
import UnitControl from "../../util/unit-control";
import {
	BORDER_STYLES, COLORS, FONT_WEIGHTS,
	NORMAL_HOVER, TEXT_TRANSFORM,
	VIEW_OPTIONS,
	STORE_TYPES,
	ORDER_OPTIONS,
	SORT_OPTIONS,
	COL_OPTIONS
} from "./constants";

import Select from 'react-select';

//external dependencies
import axios from "axios";
import Qs from 'qs';

function Inspector(props) {
	const { attributes, setAttributes, storeFilterChange } = props;

	const {
		style,
		stores,
		store_cats,
		store_type,
		store_limit,
		orderby,
		sortby,
		show_logo,
		show_title,
		show_count,
		count_after_text,
		show_desc,
		desc_limit,
		image_size,
		custom_image_width,
		custom_image_height,
		col_xl,
		col_lg,
		col_md,
		col_sm,
		col_mobile,
		titleColor,
		titleHoverColor,
		titleTypo,
		counterColor,
		counterTypo,
		contentColor,
		contentTypo,
		colBGColor,
		colBorderColor,
		colBorderWith,
		colBorderStyle,
		colBorderRadius,
		col_padding,
		gutter_padding,
		container_margin,
		container_padding,
		containerBGColor,

	} = attributes;

	const [storeCat, setStoreCat] = useState([]);
	useEffect(() => {
		let data = {
			action: 'rtcl_gb_store_category_controll',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				let storeListCats = [];
				let ai = 0;
				for (const [value, label] of Object.entries(response.data)) {
					storeListCats[ai] = { value, label };
					ai++;
				}
				setStoreCat([...storeListCats])
			})
			.catch((error) => console.log(error));
	}, []);


	const [storeList, setStoreList] = useState([]);
	useEffect(() => {
		let data = {
			action: 'rtcl_gb_store_list_controll',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				let storeListings = [];
				let ai = 0;
				for (const [value, label] of Object.entries(response.data)) {
					storeListings[ai] = { value, label };
					ai++;
				}
				setStoreList([...storeListings])
			})
			.catch((error) => console.log(error));
	}, []);

	const [imageSize, setImageSize] = useState([]);
	useEffect(() => {
		let data = {
			action: 'rtcl_gb_get_all_image_size_ajax',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				if (response.data.data) {
					let imageSize = [];
					let ai = 0;
					for (const [value, label] of Object.entries(response.data.data)) {
						imageSize[ai] = { value, label };
						ai++;
					}
					setImageSize([...imageSize])
				} else {
					setImageSize([])
				}
			})
			.catch((error) => console.log(error));
	}, []);

	const TITLE_SIZE_MAX = titleTypo["size"]["unit"] === "em" ? 10 : 100;
	const TITLE_SIZE_STEP = titleTypo["size"]["unit"] === "em" ? 0.1 : 1;

	const COUNTER_SIZE_MAX = counterTypo["size"]["unit"] === "em" ? 10 : 100;
	const COUNTER_SIZE_STEP = counterTypo["size"]["unit"] === "em" ? 0.1 : 1;

	const CONTENT_SIZE_MAX = contentTypo["size"]["unit"] === "em" ? 10 : 100;
	const CONTENT_SIZE_STEP = contentTypo["size"]["unit"] === "em" ? 0.1 : 1;

	return (
		<InspectorControls key="controls">
			<div className="rtcl-gb-panel-control">
				<TabPanel
					className="rtcl-gb-parent-tab-panel"
					activeClass="active-tab"
					tabs={[
						{
							name: "general",
							title: "General",
							className: "rtcl-gb-tab general",
						},
						{
							name: "styles",
							title: "Styles",
							className: "rtcl-gb-tab styles",
						},
						{
							name: "advance",
							title: "Advance",
							className: "rtcl-gb-tab advance",
						},
					]}
				>
					{(tab) => (
						<div className={"rtcl-gb-tab-controls" + tab.name}>

							{tab.name === "general" && (
								<>
									<PanelBody title={__("Layout", "classified-listing")} initialOpen={true}>
										<SelectControl
											label={__('View', 'classified-listing')}
											options={VIEW_OPTIONS}
											value={style}
											onChange={(style) => {
												setAttributes({ style })
											}}
										/>
									</PanelBody>

									<PanelBody title={__("Filter", "classified-listing")} initialOpen={false}>

										<SelectControl
											label={__('Store Display Type', 'classified-listing')}
											options={STORE_TYPES}
											value={store_type}
											onChange={(store_type) => {
												setAttributes({ store_type }),
													storeFilterChange()
											}}
										/>

										{store_type == 'selected' &&
											<div className="components-base-control__field">
												<label className="components-base-control__label" htmlFor="react-select-2-input">{__('Select Store', 'classified-listing')}</label>
												<Select
													options={storeList}
													value={stores}
													onChange={(value) => {
														setAttributes({ stores: value }),
															storeFilterChange()
													}}
													isMulti={true}
													closeMenuOnSelect={false}
												/>
											</div>
										}

										<div className="components-base-control__field">
											<label className="components-base-control__label" htmlFor="react-select-2-input">{__('Category', 'classified-listing')}</label>
											<Select
												options={storeCat}
												value={store_cats}
												onChange={(value) => {
													setAttributes({ store_cats: value }),
														storeFilterChange()
												}}
												isMulti={true}
												closeMenuOnSelect={false}
											/>
										</div>

										{store_type == 'all' &&
											<RangeControl
												label={__('Store Limit', 'classified-listing')}
												allowReset={true}
												value={store_limit}
												onChange={(store_limit) => {
													setAttributes({ store_limit }),
														storeFilterChange()
												}}
												min={-1}
												max={100}
											/>
										}

										<SelectControl
											label={__('Order By', 'classified-listing')}
											options={ORDER_OPTIONS}
											value={orderby}
											onChange={(value) => {
												setAttributes({ orderby: value }),
													storeFilterChange()
											}}
										/>

										<SelectControl
											label={__('Sort By', 'classified-listing')}
											options={SORT_OPTIONS}
											value={sortby}
											onChange={(value) => {
												setAttributes({ sortby: value }),
													storeFilterChange()
											}}
										/>

										<SelectControl
											label={__('Image Size', 'classified-listing')}
											options={imageSize}
											value={image_size}
											onChange={(value) => {
												setAttributes({ image_size: value }),
													storeFilterChange()
											}}
										/>

										{image_size == 'custom' &&
											<>
												<RangeControl
													label={__('Width', 'classified-listing')}
													value={custom_image_width}
													onChange={(value) => {
														setAttributes({ custom_image_width: value }),
															storeFilterChange()
													}}
													min={2}
													max={1000}
													step={2}
												/>
												<RangeControl
													label={__('Height', 'classified-listing')}
													value={custom_image_height}
													onChange={(value) => {
														setAttributes({ custom_image_height: value }),
															storeFilterChange()
													}}
													min={2}
													max={1000}
													step={2}
												/>
											</>
										}

										{/* <ToggleControl
											label={__("Hide Empty", "classified-listing")}
											checked={hide_empty}
											onChange={() => {
												setAttributes({ hide_empty: !hide_empty }),
													storeFilterChange()
											}}
										/> */}

									</PanelBody>

									<PanelBody title={__("Content Visibility", "classified-listing")} initialOpen={false}>
										<ToggleControl
											label={__("Show Logo", "classified-listing")}
											checked={show_logo}
											onChange={(show_logo) => setAttributes({ show_logo })}
										/>
										<ToggleControl
											label={__("Show Title", "classified-listing")}
											checked={show_title}
											onChange={(show_title) => setAttributes({ show_title })}
										/>
										<ToggleControl
											label={__("Show Counts", "classified-listing")}
											checked={show_count}
											onChange={(show_count) => setAttributes({ show_count })}
										/>
										{show_count == true &&
											<>
												<TextControl
													label={__("Count Text")}
													value={count_after_text}
													onChange={(count_after_text) => setAttributes({ count_after_text })}
												/>
											</>}
										<ToggleControl
											label={__("Show Description", "classified-listing")}
											checked={show_desc}
											onChange={(show_desc) => {
												setAttributes({ show_desc })
											}}
										/>

										{show_desc == true &&
											<RangeControl
												label={__('Description Limit', 'classified-listing')}
												allowReset={true}
												value={desc_limit}
												onChange={(desc_limit) => setAttributes({ desc_limit })}
												min={2}
												max={100}
											/>
										}

									</PanelBody>

									{style === 'grid' && (
										<PanelBody title={__('Responsive cols', 'classified-listing')} initialOpen={false}>
											<SelectControl
												label={__('Desktops: >1199px', 'classified-listing')}
												options={COL_OPTIONS}
												value={col_xl}
												onChange={(col_xl) => {
													setAttributes({ col_xl })
												}}
											/>
											<SelectControl
												label={__('Desktops: >991px', 'classified-listing')}
												options={COL_OPTIONS}
												value={col_lg}
												onChange={(col_lg) => {
													setAttributes({ col_lg })
												}}
											/>
											<SelectControl
												label={__('Tablets: >767px', 'classified-listing')}
												options={COL_OPTIONS}
												value={col_md}
												onChange={(col_md) => {
													setAttributes({ col_md })
												}}
											/>
											<SelectControl
												label={__('Phones: >575px', 'classified-listing')}
												options={COL_OPTIONS}
												value={col_sm}
												onChange={(col_sm) => {
													setAttributes({ col_sm })
												}}
											/>
											<SelectControl
												label={__('Small Phones: <576px', 'classified-listing')}
												options={COL_OPTIONS}
												value={col_mobile}
												onChange={(col_mobile) => {
													setAttributes({ col_mobile })
												}}
											/>
										</PanelBody>
									)}


								</>
							)}

							{tab.name === "styles" && (
								<>
									<PanelBody title={__("Box Style", "classified-listing")} initialOpen={true}>
										<RangeControl
											label={__('Gutter Spacing', 'classified-listing')}
											allowReset={true}
											value={gutter_padding}
											onChange={(gutter_padding) => {
												setAttributes({ gutter_padding })
											}}
											min={1}
											max={100}
										/>
										<BaseControl>
											<UnitControl
												selectedUnit={col_padding["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) =>
													setAttributes({
														col_padding: { ...col_padding, unit }
													})
												}
											/>
											<DimensionsControl
												label={__("Box Padding", "classified-listing")}
												top={col_padding["top"]}
												right={col_padding["right"]}
												bottom={col_padding["bottom"]}
												left={col_padding["left"]}
												onChange={({ top, right, bottom, left }) =>
													setAttributes({
														col_padding: { ...col_padding, top, bottom, left, right }
													})
												}
											/>
										</BaseControl>

										<PanelBody title={__("Background")} initialOpen={false}>
											<BaseControl label={__("Background", "classified-listing")}>
												<ColorPalette
													className="rtcl-gb-colorpalette"
													colors={COLORS}
													value={colBGColor}
													onChange={(colBGColor) => setAttributes({
														colBGColor
													})}
												/>
											</BaseControl>
										</PanelBody>

										<PanelBody title={__("Border")} initialOpen={false}>
											<SelectControl
												label={__('Border Style', 'classified-listing')}
												options={BORDER_STYLES}
												value={colBorderStyle}
												onChange={(colBorderStyle) => {
													setAttributes({ colBorderStyle })
												}}
											/>

											{(colBorderStyle !== 'none' && colBorderStyle) && (<>
												<BaseControl label={__("Width", "classified-listing")}>
													<UnitControlEMG
														value={colBorderWith}
														onChange={(colBorderWith) => setAttributes({
															colBorderWith
														})
														}
													/>
												</BaseControl>

												<ColorControl
													label={__("Border Color")}
													color={colBorderColor}
													onChange={(colBorderColor) => setAttributes({
														colBorderColor
													})
													}
												/>
											</>)}

											<BaseControl>
												<UnitControl
													selectedUnit={colBorderRadius["unit"]}
													unitTypes={[
														{ label: "px", value: "px" },
														{ label: "%", value: "%" },
													]}
													onClick={(unit) =>
														setAttributes({
															colBorderRadius: { ...colBorderRadius, unit }
														})
													}
												/>
												<DimensionsControl
													label={__("Border Radius", "classified-listing")}
													top={colBorderRadius["top"]}
													right={colBorderRadius["right"]}
													bottom={colBorderRadius["bottom"]}
													left={colBorderRadius["left"]}
													onChange={({ top, right, bottom, left }) =>
														setAttributes({
															colBorderRadius: { ...colBorderRadius, top, bottom, left, right }
														})
													}
												/>
											</BaseControl>

										</PanelBody>

									</PanelBody>

									<PanelBody title={__("Color", "classified-listing")} initialOpen={false}>
										<ColorControl
											label={__("Title")}
											color={titleColor}
											onChange={(titleColor) => setAttributes({
												titleColor
											})
											}
										/>

										<ColorControl
											label={__("Title Hover")}
											color={titleHoverColor}
											onChange={(titleHoverColor) => setAttributes({
												titleHoverColor
											})
											}
										/>

										<ColorControl
											label={__("Counter")}
											color={counterColor}
											onChange={(counterColor) => setAttributes({
												counterColor
											})
											}
										/>

										<ColorControl
											label={__("Description Color")}
											color={contentColor}
											onChange={(contentColor) => setAttributes({
												contentColor
											})
											}
										/>

									</PanelBody>

									<PanelBody title={__("Typography", "classified-listing")} initialOpen={false}>
										<BaseControl label={__("Title")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (
													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">
														<UnitControl
															selectedUnit={titleTypo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																titleTypo: { ...titleTypo, size: { ...titleTypo["size"], unit } }
															})}
														/>
														<RangeControl
															label={__("Font Size")}
															value={parseInt(titleTypo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																titleTypo: { ...titleTypo, size: { ...titleTypo["size"], lg } }
															})}
															min={0}
															step={TITLE_SIZE_STEP}
															max={TITLE_SIZE_MAX}
														/>
														<SelectControl
															label={__("Font Weight")}
															value={titleTypo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ titleTypo: { ...titleTypo, weight } })
															}
														/>
														<SelectControl
															label={__("Text Transform")}
															value={titleTypo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ titleTypo: { ...titleTypo, transform } })
															}
														/>
														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(titleTypo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ titleTypo: { ...titleTypo, spacing: { ...titleTypo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>
														<RangeControl
															label={__("Line Height")}
															value={parseInt(titleTypo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ titleTypo: { ...titleTypo, height: { ...titleTypo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>
													</div>
												)}
											/>
										</BaseControl>

										<BaseControl label={__("Counter")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (

													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">

														<UnitControl
															selectedUnit={counterTypo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																counterTypo: { ...counterTypo, size: { ...counterTypo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(counterTypo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																counterTypo: { ...counterTypo, size: { ...counterTypo["size"], lg } }
															})}
															min={0}
															step={COUNTER_SIZE_STEP}
															max={COUNTER_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={counterTypo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ counterTypo: { ...counterTypo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={counterTypo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ counterTypo: { ...counterTypo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(counterTypo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ counterTypo: { ...counterTypo, spacing: { ...counterTypo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(counterTypo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ counterTypo: { ...counterTypo, height: { ...counterTypo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>

										<BaseControl label={__("Description")} className="rtcl-gb-typography-base">
											<Dropdown
												className="rtcl-gb-typography-dropdown"
												contentClassName="my-popover-content-classname"
												position="bottom right"
												renderToggle={({ isOpen, onToggle }) => (
													<Button
														isSmall
														onClick={onToggle}
														aria-expanded={isOpen}
														icon="edit"
													></Button>
												)}
												renderContent={() => (

													<div className="rtcl-panel-control rtcl-gb-typography-component-panel">

														<UnitControl
															selectedUnit={contentTypo["size"]["unit"]}
															unitTypes={[
																{ label: "px", value: "px" },
																{ label: "%", value: "%" },
																{ label: "em", value: "em" },
															]}
															onClick={(unit) => setAttributes({
																contentTypo: { ...contentTypo, size: { ...contentTypo["size"], unit } }
															})}
														/>

														<RangeControl
															label={__("Font Size")}
															value={parseInt(contentTypo["size"]["lg"])}
															onChange={(lg) => setAttributes({
																contentTypo: { ...contentTypo, size: { ...contentTypo["size"], lg } }
															})}
															min={0}
															step={CONTENT_SIZE_STEP}
															max={CONTENT_SIZE_MAX}
														/>

														<SelectControl
															label={__("Font Weight")}
															value={contentTypo["weight"]}
															options={FONT_WEIGHTS}
															onChange={(weight) =>
																setAttributes({ contentTypo: { ...contentTypo, weight } })
															}
														/>

														<SelectControl
															label={__("Text Transform")}
															value={contentTypo["transform"]}
															options={TEXT_TRANSFORM}
															onChange={(transform) =>
																setAttributes({ contentTypo: { ...contentTypo, transform } })
															}
														/>

														<RangeControl
															label={__("Letter Spacing")}
															value={parseInt(contentTypo["spacing"]["lg"])}
															onChange={(lg) =>
																setAttributes({ contentTypo: { ...contentTypo, spacing: { ...contentTypo["spacing"], lg } } })
															}
															min={0}
															max={10}
														/>

														<RangeControl
															label={__("Line Height")}
															value={parseInt(contentTypo["height"]["lg"])}
															onChange={(lg) =>
																setAttributes({ contentTypo: { ...contentTypo, height: { ...contentTypo["height"], lg } } })
															}
															min={-1}
															max={100}
														/>

													</div>
												)}
											/>
										</BaseControl>

									</PanelBody>
								</>
							)}

							{tab.name === "advance" && (
								<>
									<PanelBody title={__("Main Wrapper", "classified-listing")} initialOpen={true}>

										<BaseControl>
											<UnitControl
												selectedUnit={container_padding["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) => setAttributes({
													container_padding: { ...container_padding, unit },
												})
												}
											/>
											<DimensionsControl
												label={__("Main Wrapper Padding", "classified-listing")}
												top={container_padding["top"]}
												right={container_padding["right"]}
												bottom={container_padding["bottom"]}
												left={container_padding["left"]}
												onChange={({ top, right, bottom, left }) => setAttributes({
													container_padding: { ...container_padding, top, bottom, left, right },
												})
												}
											/>
										</BaseControl>

										<BaseControl>
											<UnitControl
												selectedUnit={container_margin["unit"]}
												unitTypes={[
													{ label: "px", value: "px" },
													{ label: "em", value: "em" },
													{ label: "%", value: "%" },
												]}
												onClick={(unit) => setAttributes({
													container_margin: { ...container_margin, unit },
												})
												}
											/>
											<DimensionsControl
												label={__("Main Wrapper Margin", "classified-listing")}
												top={container_margin["top"]}
												right={container_margin["right"]}
												bottom={container_margin["bottom"]}
												left={container_margin["left"]}
												onChange={({ top, right, bottom, left }) => setAttributes({
													container_margin: { ...container_margin, top, bottom, left, right },
												})
												}
											/>
										</BaseControl>

										<BaseControl label={__("Background Color", "classified-listing")}>
											<ColorPalette
												className="rtcl-gb-colorpalette"
												colors={COLORS}
												value={containerBGColor}
												onChange={(containerBGColor) => setAttributes({
													containerBGColor
												})}
											/>
										</BaseControl>

									</PanelBody>
								</>
							)}

						</div>
					)}
				</TabPanel>
			</div>
		</InspectorControls >
	)

}

export default Inspector;